import React from "react";

const Alumni = () => {
  return (
    <section className="w-full bg-gradient-to-b from-[#f8fafc] to-[#eef2ff] py-20 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block mb-4 px-4 py-1 text-sm font-semibold text-white bg-[#112E65] rounded-full">
            Alumni Association
          </span>
          <h2 className="text-4xl font-bold text-[#112E65] mb-6">
            Our Alumni, Our Pride
          </h2>
          <p className="text-gray-600 leading-relaxed">
            Our alumni are our greatest asset and ambassadors. The Sumatidevi
            Tompe Institute Alumni Association is a vibrant network connecting
            past graduates with the institute and with each other.
          </p>
        </div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="bg-white rounded-2xl shadow-xl p-10">
            <h3 className="text-2xl font-bold text-[#112E65] mb-4">
              Alumni Engagement
            </h3>
            <p className="text-gray-600 leading-relaxed mb-6">
              The Alumni Association strengthens the bond between former
              students and the institute while supporting professional growth
              and meaningful collaboration.
            </p>

            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <span className="w-3 h-3 mt-2 rounded-full bg-[#112E65]"></span>
                <p className="text-gray-700">
                  Networking opportunities with alumni and industry professionals
                </p>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-3 h-3 mt-2 rounded-full bg-[#112E65]"></span>
                <p className="text-gray-700">
                  Mentorship programs for students and young professionals
                </p>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-3 h-3 mt-2 rounded-full bg-[#112E65]"></span>
                <p className="text-gray-700">
                  Career guidance and continuous professional development
                </p>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-3 h-3 mt-2 rounded-full bg-[#112E65]"></span>
                <p className="text-gray-700">
                  Participation in academic, cultural, and alumni events
                </p>
              </li>
            </ul>
          </div>

          {/* Right Information */}
          <div className="bg-[#112E65] rounded-2xl shadow-xl p-10 text-white">
            <h3 className="text-3xl font-bold mb-4">
              Stay Connected. Stay Inspired.
            </h3>
            <p className="text-white/90 leading-relaxed">
              The Alumni Association plays an active role in nurturing lifelong
              relationships, promoting knowledge sharing, and strengthening the
              institute community.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Alumni;
